module.exports = __webpack_public_path__ + "media/images/temp-indicator-1-2c32a67660c0f4820624184e4166099d.svg";